export const SET_PREVIOUS_LOCATION = 'SET_PREVIOUS_LOCATION';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
